var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1C1.34315 1 0 2.34315 0 4V19C0 20.6569 1.34315 22 3 22H21C22.6569 22 24 20.6569 24 19V7C24 5.34315 22.6569 4 21 4H10.9142C10.649 4 10.3946 3.89464 10.2071 3.70711L7.79289 1.29289C7.60536 1.10536 7.351 1 7.08579 1H3Z",
    fill: "#C2C7CB"
  })));
};

export default __webpack_public_path__ + "static/media/folder.82a4b71d.svg";
export { SvgComponent as ReactComponent };